import { EnumRouteCollectionType, MapRouteCollection } from "src/dto.generated/api";

export function getRouteCollectionTypeName(collectionType: EnumRouteCollectionType, languageCode: string) {
    let routeCollectionTypeName: string;
    if (languageCode === "de") {
        if (collectionType === EnumRouteCollectionType.EuroVelo) { routeCollectionTypeName = "EuroVelo Route"; }
        if (collectionType === EnumRouteCollectionType.LongRoute) { routeCollectionTypeName = "Mehretappenroute"; }
        if (collectionType === EnumRouteCollectionType.Group) { routeCollectionTypeName = "Routenzusammenstellung"; }
        if (collectionType === EnumRouteCollectionType.BestOf) { routeCollectionTypeName = "Best of Auswahl"; }
    }
    if (languageCode !== "de") {
        if (collectionType === EnumRouteCollectionType.EuroVelo) { routeCollectionTypeName = "EuroVelo route"; }
        if (collectionType === EnumRouteCollectionType.LongRoute) { routeCollectionTypeName = "Long distance route"; }
        if (collectionType === EnumRouteCollectionType.Group) { routeCollectionTypeName = "Route collection"; }
        if (collectionType === EnumRouteCollectionType.BestOf) { routeCollectionTypeName = "Best of collection"; }
    }
    return routeCollectionTypeName;
}

export function getRouteCollectionNameForLanguage(routeCollection: MapRouteCollection, languageCode: string) {
    // console.log("utils-route-collections:getRouteCollectionNameForLanguage-routeCollection", routeCollection);
    if (typeof (routeCollection.name) === "string") {
        console.log("utils-route-collections:getRouteCollectionNameForLanguage-string");
    }
    let name = "";
    const map = (routeCollection.name as any) as Map<string, string>;
    name = map.get(languageCode);
    // if (!name) { name = map.get("en"); }
    // if (!name) { name = map.get("de"); }
    return name;
}

export function getRouteCollectionDescriptionForLanguage(routeCollection: MapRouteCollection, languageCode: string) {
    // console.log("utils-route-collections:getRouteCollectionDescriptionForLanguage-routeCollection", routeCollection);
    let description = "";
    const map = (routeCollection.description as any) as Map<string, string>;
    description = map.get(languageCode);
    // if (!description) { description = map.get("en"); }
    // if (!description) { description = map.get("de"); }
    return description;
}

export function parseLoadedRouteCollection(routeCollection: MapRouteCollection) {
    // console.log("utils-route-collections:parseLoadedRouteCollection-routeCollection1", routeCollection);
    if (typeof (routeCollection.name) === "string") {
        const arr = JSON.parse(routeCollection.name);
        (routeCollection.name as any) = new Map<string, string>(arr);
    }
    if (typeof (routeCollection.description) === "string") {
        const arr = JSON.parse(routeCollection.description);
        (routeCollection.description as any) = new Map<string, string>(arr);
    }
    // console.log("utils-route-collections:parseLoadedRouteCollection-routeCollection2", routeCollection); 
}
